import React from 'react';
import { Card, Button, Image } from 'react-bootstrap';
import register from '../assets/images/register.png';

/* Card used in the Register page from My Account, displays an icon, a title, a description,
a link to get more informations, and a button to register.*/

const RegisterCard = ({item,handleClickForm}) => {
    return (
        <Card className="h-100">
            <Card.Body className="d-flex flex-column p-0">
            <div className="d-flex align-items-center mb-3" style={{backgroundColor:"#ededff", padding:"10px"}}>
                <img src={item.icon} alt={item.title} height="50" className="mr-3" />
                <Card.Title style={{padding:"10px"}}>{item.title}</Card.Title>
            </div>
            <Card.Text style={{padding:"10px"}}>
                {item.description}
                {/* Read more link, goes to the corresponding About Us page.*/}
                <a href={item.link} className="ml-2">Read more</a>
            </Card.Text>
            <Button variant="light" 
                className="mt-auto btn-sm px-3 py-1 text-start align-self-start border-0"  
                onClick={handleClickForm}
                style={{ 
                    backgroundColor: "white", 
                    boxShadow: "none",
                }}
            >
                <div className="d-flex align-items-center" style={{marginBottom:"10px"}}>
                    <Image src={register} width={32} height={32} alt="Register Icon" />
                    <span className='ms-2' style={{color: "#7300FF", fontWeight: "bold"}}>{item.buttonText}</span>
                </div>
            </Button>
            </Card.Body>
        </Card>
    );
};

export default RegisterCard;